require("./chat.scss")
import { l, l_html } from '../../locale/locale';

var chat_html = require("./chat.html")
var chat_button = require("./chat_button.html")
var mine_html = require("./message_me.html")
var yours_html = require("./message_them.html")
const HIDDEN_DELAY = 10000;
const SHOWN_DELAY = 5000;

class ChatBuilder {
  constructor() {
    var body = $("body");
    this.target = $(l_html(chat_html));
    var button = $(chat_button);
    body.append(this.target);
    body.append(button);
    this.sendMessageContainer = this.target.find("#send-messages-container");
    this.modal = this.target.find("#chatModal");
    this.messages = this.target.find("#messages");
    this.isModalShown = false;
    this.unreadMessages = button.find("#unread-messages");
  }

  setup() {
    this.retrieve_messages_from_backend();
    this.interval = setInterval(() => { this.retrieve_messages_from_backend(); }, HIDDEN_DELAY);
    this.sendMessageContainer.find("#submit-message-button").on('click', () => { this.send_message(); });
    this.sendMessageContainer.find("input").on('keypress', (event) => {
      var keycode = event.key;
      if (keycode == 'Enter') {
        this.send_message();
      }
    });
    this.target.on("shown.bs.modal", () => { this.modal_shown(); });
    this.target.on("hidden.bs.modal", () => { this.modal_hidden(); });
  }

  addMessages(data) {
    var messages = data['messages'];
    this.messages.empty();
    messages.forEach((k) => {
      this.append_message( k['text'], k["sent_by_me"], k["user"], k["date"]);
    });
  }

  retrieve_messages_from_backend() {
    $.ajax({
      url: `/api/chat_messages`
    }).done((data) => {
      this.addMessages(data);

      if (this.isModalShown === true) {
        this.set_cookie();
        this.unreadMessages.hide();
      }

      if (this.get_cookie() < this.get_number_of_messages()) {
        this.unreadMessages.show();
        this.unreadMessages.text(this.get_number_of_messages() - this.get_cookie());
      }

    });

  }

  send_message() {

    var text = this.sendMessageContainer.find("input").val();
    this.sendMessageContainer.find("input").val(null);
    if (text) {
      var data = { "text": text };
      $.ajax({
        type: "POST",
        url: `/api/chat_messages`,
        data: data,
        statusCode: {
          201: () =>  {
            this.append_message(text, true, "", "");
            this.set_cookie();
          }
        }
      });
    } //TODO HANDLE ERROR
  }

  modal_shown() {
    clearInterval(this.interval);
    this.set_cookie();
    this.interval = setInterval(() => { this.retrieve_messages_from_backend(); }, SHOWN_DELAY);
    this.isModalShown = true;
    this.unreadMessages.hide();
    this.target.find(".modal-body").scrollTop(10000);
    this.sendMessageContainer.find("input").trigger('focus');

  }

  modal_hidden() {
    clearInterval(this.interval);
    this.interval = setInterval(() => { this.retrieve_messages_from_backend(); }, HIDDEN_DELAY);
    this.isModalShown = false;
  }

  set_cookie() {
    var value = this.get_number_of_messages();
    document.cookie = "_coclick_number_of_chat_message_seen=" + value;
  }

  get_cookie() {
    var cookie = document.cookie.split('; ').find(row => row.startsWith('_coclick_number_of_chat_message_seen'));
    if (cookie) {
      return cookie.split("=")[1];
    } else {
      return 0;
    }
  }

  get_number_of_messages() {
    return this.messages.find(".message").length
  }

  append_message(text, isMe, user, date) {
    if (isMe) {
      var mine = $(mine_html)
      mine.find(".content").html(text);
      if(user !== "") {
        mine.find(".date_name").html(`${l('Chat_sent')} | ` + date)
      }
      this.messages.append(mine);
    } else {
      var yours = $(yours_html)
      yours.find(".content").html(text);
      yours.find(".date_name").html(user + " | " + date)
      this.messages.append(yours);
    }

    this.target.find(".modal-body").scrollTop(10000);

  }
}

export default ChatBuilder;
